import { render } from "./closeCRMWhatsappConversationDialog.vue?vue&type=template&id=493dc67b&scoped=true"
import script from "./closeCRMWhatsappConversationDialog.vue?vue&type=script&lang=js"
export * from "./closeCRMWhatsappConversationDialog.vue?vue&type=script&lang=js"

import "./closeCRMWhatsappConversationDialog.vue?vue&type=style&index=0&id=493dc67b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493dc67b"]])

export default __exports__